import _toConsumableArray from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.filter";
import _defineProperty from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.index-of";
import _slicedToArray from "/var/lib/jenkins/workspace/auto-deploy-prod/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import Duration from "../duration.js";

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
    return dt.toUTC(0, {
      keepLocalTime: true
    }).startOf("day").valueOf();
  },
      ms = utcDayStart(later) - utcDayStart(earlier);

  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var lowestOrder, highWater;

  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _slicedToArray(_differs[_i], 2),
        unit = _differs$_i[0],
        differ = _differs$_i[1];

    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      var delta = differ(cursor, later);
      highWater = cursor.plus(_defineProperty({}, unit, delta));

      if (highWater > later) {
        cursor = cursor.plus(_defineProperty({}, unit, delta - 1));
        delta -= 1;
      } else {
        cursor = highWater;
      }

      results[unit] = delta;
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

export default function (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
      _highOrderDiffs2 = _slicedToArray(_highOrderDiffs, 4),
      cursor = _highOrderDiffs2[0],
      results = _highOrderDiffs2[1],
      highWater = _highOrderDiffs2[2],
      lowestOrder = _highOrderDiffs2[3];

  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus(_defineProperty({}, lowestOrder, 1));
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  var duration = Duration.fromObject(Object.assign(results, opts));

  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;

    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, _toConsumableArray(lowerOrderUnits)).plus(duration);
  } else {
    return duration;
  }
}